export default () => ({
  cities: [],
  states: [],
  colonies: [],

  // * 08/11/2022 - TAG: Return back to the original route
  originRouteToCustomerForm: null,
})
